import { render, staticRenderFns } from "./Pace.vue?vue&type=template&id=1e85a354&scoped=true&"
import script from "./Pace.vue?vue&type=script&lang=js&"
export * from "./Pace.vue?vue&type=script&lang=js&"
import style0 from "./Pace.vue?vue&type=style&index=0&id=1e85a354&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e85a354",
  null
  
)

export default component.exports